import AreaFilterDefinition from '../AreaFilterDefinition';
import AttendanceFilterDefinition from '../AttendanceFilterDefinition';
import { CountryFilterDefinition } from '../CountryFilterDefinition';
import ContinentFilterDefinition from '../ContinentFilterDefinition';
import DisciplineFilterDefinition from '../DisciplineFilterDefinition';
import { EducationLevelFilterOptionValue } from '@studyportals/search-filters/server-side';
import FormatFilterDefinition from '../FormatFilterDefinition';
import { PortalDefinition } from '../PortalDefinition';
import ShortCoursesDegreeTypeFilterDefinition from './ShortCoursesDegreeTypeFilterDefinition';
import ShortCoursesDurationFilterDefinition from './ShortCoursesDurationFilterDefinition';
import ShortCoursesEducationalFormFilterDefinition from './ShortCoursesEducationalFormFilterDefinition';
import ShortCoursesSpecialProgrammesFilterDefinition from './ShortCoursesSpecialProgrammesFilterDefinition';
import TuitionFeeFilterDefinition from '../TuitionFeeFilterDefinition';
import OrganisationFilterDefinition from '../OrganisationFilterDefinition';
import  CampaignTypeFilterDefinition  from '../CampaignTypeFilterDefinition';

class ShortCoursesPortalDefinition extends PortalDefinition {
	private educationalFormFilterDefinition = ShortCoursesEducationalFormFilterDefinition;

	public constructor() {
		super(
			[
				OrganisationFilterDefinition,
				AttendanceFilterDefinition,
				ShortCoursesDegreeTypeFilterDefinition,
				DisciplineFilterDefinition,
				ShortCoursesDurationFilterDefinition,
				FormatFilterDefinition,
				TuitionFeeFilterDefinition,
				ShortCoursesSpecialProgrammesFilterDefinition,
				AreaFilterDefinition,
				ContinentFilterDefinition,
				CampaignTypeFilterDefinition,
				new CountryFilterDefinition(),
			],
			['82', '30', '1', '202', '15'],
			'Short courses',
			'course',
			EducationLevelFilterOptionValue.SHORT_COURSE,
			'Short Courses',
		);

		this.filterDefinitions.push(this.educationalFormFilterDefinition);
	}
}

export default new ShortCoursesPortalDefinition();
